import hoistNonReactStatic from 'hoist-non-react-statics';
import getDisplayName from '../../../utils/getDisplayName';

export function handleKeyChange(options) {
    return WrappedComponent => {
        const { keyChangeType } = options;

        const wrappedDisplayName = `HandleKeyChangeView(${getDisplayName(WrappedComponent)})`;

        class HandleKeyChangeView extends WrappedComponent {
            static displayName = wrappedDisplayName;

            componentDidMount() {
                if (WrappedComponent.prototype.componentDidMount) {
                    WrappedComponent.prototype.componentDidMount.apply(this);
                }

                this.onKeyChange = this.onKeyChange.bind(this);
                document.addEventListener(keyChangeType, this.onKeyChange);
            }

            componentWillUnmount() {
                if (WrappedComponent.prototype.componentWillUnmount) {
                    WrappedComponent.prototype.componentWillUnmount.apply(this);
                }

                document.removeEventListener(keyChangeType, this.onKeyChange);
            }
        }

        return hoistNonReactStatic(HandleKeyChangeView, WrappedComponent);
    };
}
